import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/carousel/styles.css'

// Handle GitHub Pages 404 redirect - restore the original path
// When GitHub Pages serves 404.html, it redirects to index.html
// and stores the original path in sessionStorage
const redirectPath = sessionStorage.getItem('redirectPath')
if (redirectPath) {
  sessionStorage.removeItem('redirectPath')
  // Restore the original path using history API
  window.history.replaceState({}, '', redirectPath)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

